/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wide_Gray_Lark_JumpInputs */

const en_wide_gray_lark_jump = /** @type {(inputs: Wide_Gray_Lark_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Manage files shared with this member`)
};

const de_wide_gray_lark_jump = /** @type {(inputs: Wide_Gray_Lark_JumpInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dateien verwalten, die mit diesem Mitglied geteilt wurden`)
};

/**
* | output |
* | --- |
* | "Manage files shared with this member" |
*
* @param {Wide_Gray_Lark_JumpInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const wide_gray_lark_jump = /** @type {((inputs?: Wide_Gray_Lark_JumpInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wide_Gray_Lark_JumpInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_wide_gray_lark_jump(inputs)
	return de_wide_gray_lark_jump(inputs)
});